import { API_V1, fetchApi } from '../utils/fetchApi';

export default abstract class CPaymentService {
  static getIsETHAvailable = async () =>
    fetchApi<{ is_available: boolean }>(API_V1, '/cp/is-available', {
      params: { symbol: 'eth' },
    });
}
